export const SUPPLIER_DOCUMENT_DROP_DOWN_ITEMS = []